import React from "react"

import Icon from "../Icon"
import smgLoader from "./smg-loader.jpg"
import "./index.scss"

const Loader = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-3 d-flex loader-container">
        <div className="loader">
          <img src={smgLoader} alt="" />
          <Icon name="spinner" spin={true} />
        </div>
      </div>
    </div>
  )
}

export default Loader
